import { Injectable } from '@angular/core';
import { IActivity } from '@shared/interfaces/activity.interface';
import { CandidatesActivitiesService } from '@shared/services/candidates/candidates.activities.service';
import { LoggerService } from '@shared/services/logger.service';
import { PaginationService } from '@shared/services/pagination/pagination.service';

@Injectable({
  providedIn: 'root'
})
export class PaginationCandidatesActivitiesService extends PaginationService<IActivity> {
  constructor(_paginable: CandidatesActivitiesService, _logger: LoggerService) {
    super(_paginable, _logger);
  }
}
